import { accessTokens } from 'api/accessTokenMgmt'

export type SwapCurrency = { ticker: string; label: string }
export type SwapLimits = { from: string; minimum: string; maximum: string; maximum_usd?: string }
export type SwapQuote = {
    from: string
    amount: string
    address: string
    expected_bsv: string
    network_fee: string
    minimum: string
    maximum: string
    maximum_usd?: string
    capped?: boolean
    rate_bsv: string
    usd_per_unit?: string
    quote_token: string
    expires_at: string
}
export type SwapTransaction = {
    id: string
    external_id: string | null
    status: string
    active?: boolean
    from_currency: string
    currency_label: string
    from_amount: string
    expected_bsv: string
    actual_bsv: string | null
    payout_address: string
    payin_address: string | null
    payin_extra_id: string | null
    output_hash: string | null
    error: string | null
    created_at: string
    updated_at?: string
    completed_at?: string | null
}

export async function changellyRequest<T>(
    path: string,
    body?: unknown,
    signal?: AbortSignal,
): Promise<T> {
    const controller = new AbortController()
    const abort = () => controller.abort()
    signal?.addEventListener('abort', abort, { once: true })
    if (signal?.aborted) controller.abort()
    const timeout = window.setTimeout(() => controller.abort(), 30000)
    try {
        const response = await fetch(`${window.knovApiUrl}/api/v1/changelly/${path}`, {
            method: body === undefined ? 'GET' : 'POST',
            headers: {
                ...accessTokens(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...(body === undefined ? {} : { body: JSON.stringify(body) }),
            signal: controller.signal,
        })
        const result = await response.json()
        if (!response.ok) {
            const error = new Error(result.error || 'Could not load swap information.') as Error & {
                status?: number
                code?: string
            }
            error.status = response.status
            if (typeof result.code === 'string') error.code = result.code
            throw error
        }
        return result
    } finally {
        window.clearTimeout(timeout)
        signal?.removeEventListener('abort', abort)
    }
}
